const {
	REACT_APP_TAG_UPDATE_ON,
	REACT_APP_TAG_UPDATE_ENDPOINT,
	REACT_APP_TAG_UPDATE_KEY,
	REACT_APP_TAG_UPDATE_TOKEN,
} = process.env

const DEFAULT_HEADERS = {
  "Accept": "application/json",
  "Content-Type": "application/json",
}

export function updateTagApi(data) {
	if(REACT_APP_TAG_UPDATE_ON) {
	  return fetch(REACT_APP_TAG_UPDATE_ENDPOINT, {
	    method: "POST",
	    headers: {
	      ...DEFAULT_HEADERS,
	      [REACT_APP_TAG_UPDATE_KEY]: REACT_APP_TAG_UPDATE_TOKEN,
	    },
	    body: JSON.stringify({
	    	...data,
	    })
	  })
	}

	return null
}